import { RootStore } from 'bzx-common/src/stores'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { Button, Icon } from 'ui-framework'
import { chainConfigs, ChainId, supportedChains } from '../../config/appConfig'

type Feature = 'staking'

interface IFeatureDesc {
  label: string
  available: { link: string; slogan: string; chainId: ChainId }[]
}

const featureMap: Record<Feature, IFeatureDesc> = {
  staking: {
    label: 'Staking',
    available: [
      {
        link: 'https://app.fulcrum.trade/stake',
        slogan: 'Stake on Ethereum',
        chainId: 1,
      },
    ],
  },
}

interface IFeatureNetworkSwitch {
  feature: 'staking'
  children?: React.ReactNode
  allChainsSwitches?: boolean
  rootStore: RootStore
}

/**
 * Note: this is currently based on the website domains.
 * NOT the network the user is connected to, until we have the apps working on any network.
 */
export function FeatureNetworkSwitch(props: any) {
  const { feature, rootStore, children, allChainsSwitches } = props as IFeatureNetworkSwitch
  const { web3Connection } = rootStore
  const featureDetails = featureMap[feature]

  return (
    <div className="txt-default txt-center txt-size-12 margin-top-2">
      {children || (
        <div className="margin-bottom-2">
          <p>{featureDetails.label} is available on these networks:</p>
        </div>
      )}

      <div className="network-switch__links">
        {allChainsSwitches &&
          supportedChains.map((chainId) => {
            const { name, color } = chainConfigs[chainId].icon
            return (
              <Button
                key={chainId}
                className="flex-row-center"
                variant="neutral"
                onClick={() => web3Connection.switchNetwork(chainId)}>
                <Icon className="margin-right-1" name={name} color={color} />
                {chainConfigs[chainId].chainDetails.chainName}
              </Button>
            )
          })}
        {!allChainsSwitches &&
          featureDetails.available.map((details) => {
            const { name, color } = chainConfigs[details.chainId].icon
            return (
              <Button
                key={details.chainId}
                className="flex-row-center"
                variant="neutral"
                onClick={() => web3Connection.switchNetwork(details.chainId)}>
                <Icon className="margin-right-1" name={name} color={color} />
                {details.slogan}
              </Button>
            )
          })}
      </div>
    </div>
  )
}

export default inject('rootStore')(observer(FeatureNetworkSwitch))
